import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDailymotionComponent } from './simple-icons-dailymotion.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDailymotionComponent ],
    exports:      [ SimpleIconsDailymotionComponent ],
    bootstrap:    []
})
export class SimpleIconsDailymotionModule {}
